import React, {FC} from 'react';
import {useLocation} from '@reach/router';
import classNames from 'classnames';
import FullRow from 'components/ContentPagesComponents/FullRow';
import DynamicAsset from 'components/DynamicAsset';
import MediaQuery from 'components/utils/MediaQuery';
import {COLORS} from 'constants/index';

import * as styles from './styles.module.scss';

interface IImageRowProps {
	imageSrc: string;
	mobileSrc?: string;
	backgroundColor?: string;
}

const ImageRow: FC<IImageRowProps> = ({
	imageSrc,
	mobileSrc,
	backgroundColor = COLORS.SALAD60,
}) => {
	const location = useLocation();
	const isHomePage = location.pathname === '/';
	const bgColor = isHomePage ? backgroundColor : COLORS.WHITE;
	return (
		<div style={{backgroundColor: bgColor}}>
			<div className={classNames(styles.container)}>
				<div className={styles.content}>
					<FullRow>
						{mobileSrc ? (
							<>
								<MediaQuery desktop>
									<DynamicAsset
										imageSrc={imageSrc}
										className='w-100 img-fluid'
									/>
								</MediaQuery>
								<MediaQuery mobile>
									<DynamicAsset
										imageSrc={mobileSrc}
										className='w-100 img-fluid'
									/>
								</MediaQuery>
							</>
						) : (
							<DynamicAsset
								imageSrc={imageSrc}
								className='w-100 img-fluid'
							/>
						)}
					</FullRow>
				</div>
			</div>
		</div>
	);
};

export default ImageRow;
